import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import { formatDateToYMDEGeneral } from "@/shared/utils";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function OrderHistoryDetail() {
  const { data } = useOrderHistoryDetail();
  const { i18n, t } = useI18nHelper();

  return (
    <Flex alignItems={"center"} whiteSpace={"nowrap"}>
      <Text textStyle={"body-md-medium"} color={"#444444"}>
        {t("order_history:order_number")} P{data?.id}
      </Text>
      <Flex
        color={"#6F6F6C"}
        alignItems={"center"}
        textStyle={"body-md-regular"}
      >
        <CustomIcon src={"dot"} width={16} height={16} color={"#D4D4D1"} />
        <Text>
          {formatDateToYMDEGeneral(
            data?.updated_at,
            i18n.language === "ko",
            "-",
            true
          )}{" "}
          {t("submitted")}
        </Text>
        <CustomIcon src={"dot"} width={16} height={16} color={"#D4D4D1"} />
        <Text>
          {t(
            "line_sheet_set.types." +
              data?.line_sheet_set?.type?.toLowerCase() ?? ""
          )}
        </Text>
        <CustomIcon src={"dot"} width={16} height={16} color={"#D4D4D1"} />
        <Text>
          {t("supplier")} {data?.line_sheet_set?.issued_by_boutique?.name}
        </Text>
      </Flex>
    </Flex>
  );
}

export default OrderHistoryDetail;
